<template lang="pug">
v-btn(
  v-bind="$data.$_attrs"
  v-on="$data.$_listeners"
  :color="color"
  :class="classes"
  :dark="isDarkThemeColour"
  :ripple="false"
).pa-0
  slot
</template>

<script>
import { Sizeable, BindsAttrs } from '@/mixins'

export default {
  mixins: [
    Sizeable,
    BindsAttrs,
  ],
  inheritAttrs: false,
  props: {
    /**
     * Will make the button take the full container width on screen sizes sm and xs.
     * The default behaviour is not to resize.
     */
    responsive: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'brand-pink'
    },
    dark: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    /**
     * Conditionally set the theme to dark if we're using our brand-pink or a dark brand colour
     * @returns {boolean}
     */
    isDarkThemeColour () {
      return this.dark || this.color === 'brand-pink' || this.color === 'brand-light-pink' || this.color.includes('brand-dark')
    },
    classes () {
      return {
        'k-button': true,
        'k-button--responsive': this.responsive,
        'k-button--x-small': this.xSmall,
        'k-button--small': this.small,
        ...this.sizeClasses
      }
    },
  }
}
</script>

<style lang="scss" scoped>
$height-medium: 55px;
$height-small: 40px;
$height-x-small: 30px;

.k-button {
  border-radius: 5px;
  max-width: 100%;
  min-width: 50px;

  &.v-btn--round {
    border-radius: 50% !important;
  }

  &:not(.v-btn--block) {
    margin: 6px 8px;
  }

  &.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
    background-color: var(--v-brand-grey-40-base) !important;
    color: white !important;
  }

  &:hover,
  &--active{
    opacity: .8;
  }

  &::before {
    display: none !important;
  }

  // Size styling
  // Default
  ::v-deep {
    @extend %small-caps--large;
    height: $height-medium !important;

    .v-btn__content {
      font-weight: bold;
      line-height: 100%;
      padding: 0 30px;
    }
  }

  // Small
  &--small {
    ::v-deep {
      height: $height-small !important;

      .v-btn__content {
        padding: 0 21px;
      }
    }
  }

  // X Small
  &--x-small {
    ::v-deep {
      height: $height-x-small !important;

      .v-btn__content {
        @extend %small-caps--small;
        padding: 0 6px;

        @include md-and-up {
          padding: 0 12px;
        }
      }
    }
  }

  // Responsive
  &--responsive {
    @include sm-and-down {
      display: flex;
      margin: 6px 0;
      width: 100%;
    }
  }
}
</style>
